import axios from "axios";
import objectPath from "object-path";
import React, { useState, useEffect } from "react";
import AdviceItem from "./components/item";

const Index = () => {
  const [loading, setloading] = useState(false);
  const [data, setdata] = useState(null);
  const [offset, setoffset] = useState(0);
  useEffect(() => {
    const fetch = async () => {
      setloading(true);
      const result = await axios({
        url: "/service/advice",
        method: "POST",
        auth: {
          username: "hsct",
          password:
            "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
        },
        data: {
          offset: offset,
          limit: 20,
          sort: { _id: -1 },
        },
      });
      setdata(objectPath.get(result, "data.items"));
      setloading(false);
    };
    fetch();
  }, []);

  return (
    <div>
      {loading ? (
        <div></div>
      ) : (
        <div className="flex flex-col w-full justify-center md:justify-start p-8 mb-20">
          {data?.map((row, index) => (
            <AdviceItem data={row} key={index} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Index;
